module.exports = __webpack_public_path__ + "static/img/sales_poster_two_2.5ae0a247.jpg";